var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    { attrs: { id: "createModal", title: "Secure Edit Customer" } },
    [
      _c(
        "form",
        {
          key: _vm.stateChangeKey,
          attrs: { id: "creator_form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitModalForm.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-wrap align-items-center justify-content-between mt-3"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between gap w-100" },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v("One Time Passcode")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.inputOTP
                ? _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("AppInput", {
                        staticClass: "form-group",
                        staticStyle: { width: "300px" },
                        attrs: {
                          error:
                            _vm.ajax_error &&
                            _vm.ajax_error.errors &&
                            _vm.ajax_error.errors.otp,
                          warning: _vm.ajax_warnings.otp,
                          placeholder: _vm.$t("XXXXXXX"),
                          dataTestId: "secure-edit",
                          uppercase: true,
                          name: "otp"
                        },
                        model: {
                          value: _vm.form.otp,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "otp", $$v)
                          },
                          expression: "form.otp"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "AppButton",
                        {
                          staticClass: "py-2 md-flat ml-2 mb-3",
                          staticStyle: { width: "100px" },
                          attrs: {
                            name: "request-otp",
                            outline: "",
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              _vm.inputOTP = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("New Code")) + "\n\t\t\t\t")]
                      )
                    ],
                    1
                  )
                : _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("AppInput", {
                          staticClass: "form-group otp-input",
                          attrs: {
                            label:
                              "[Optionally] Specify an email address to send OTP",
                            error:
                              _vm.ajax_error &&
                              _vm.ajax_error.errors &&
                              _vm.ajax_error.errors.otp,
                            warning: _vm.ajax_warnings.otp,
                            placeholder: _vm.$t(""),
                            dataTestId: "otp-via-email",
                            name: "otpViaEmail"
                          },
                          model: {
                            value: _vm.form.viaEmail,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "viaEmail", $$v)
                            },
                            expression: "form.viaEmail"
                          }
                        }),
                        _vm._v(" "),
                        _c("AppInput", {
                          staticClass: "form-group otp-input",
                          attrs: {
                            label:
                              "[Optionally] Specify a phone number to send OTP",
                            error:
                              _vm.ajax_error &&
                              _vm.ajax_error.errors &&
                              _vm.ajax_error.errors.otp,
                            warning: _vm.ajax_warnings.otp,
                            placeholder: _vm.$t("(area code) 123-456-7890"),
                            dataTestId: "otp-via-sms",
                            name: "otpViaSMS"
                          },
                          on: { select: _vm.onSelect },
                          model: {
                            value: _vm.form.viaSMS,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "viaSMS", $$v)
                            },
                            expression: "form.viaSMS"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-row justify-content-end"
                          },
                          [
                            _c(
                              "AppButton",
                              {
                                staticClass: "py-2 md-flat ml-2 mb-3",
                                attrs: {
                                  name: "request-otp",
                                  outline: "",
                                  type: "button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sendOTP()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Send Code")) + "\n\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "AppButton",
                              {
                                staticClass: "py-2 md-flat ml-2 mb-3",
                                attrs: {
                                  name: "request-otp",
                                  outline: "",
                                  type: "button"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.inputOTP = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Use Code")) + "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _c("AppInput", {
            staticClass: "form-group",
            attrs: {
              label: _vm.$t("Username"),
              error:
                _vm.ajax_error &&
                _vm.ajax_error.errors &&
                _vm.ajax_error.errors.username,
              warning: _vm.ajax_warnings && _vm.ajax_warnings.username,
              placeholder: _vm.$t("Username"),
              name: "username",
              dataTestId: "username"
            },
            on: {
              change: function($event) {
                return _vm.onBlurChangeWarning("username")
              }
            },
            model: {
              value: _vm.form.username,
              callback: function($$v) {
                _vm.$set(_vm.form, "username", $$v)
              },
              expression: "form.username"
            }
          }),
          _vm._v(" "),
          _c("AppInput", {
            staticClass: "form-group",
            attrs: {
              label: _vm.$t("Full Name"),
              error:
                _vm.ajax_error &&
                _vm.ajax_error.errors &&
                _vm.ajax_error.errors.full_name,
              warning: _vm.ajax_warnings && _vm.ajax_warnings.full_name,
              placeholder: _vm.$t("Your Name"),
              name: "full_name",
              dataTestId: "full-name"
            },
            on: {
              change: function($event) {
                return _vm.onBlurChangeWarning("full_name")
              }
            },
            model: {
              value: _vm.form.full_name,
              callback: function($$v) {
                _vm.$set(_vm.form, "full_name", $$v)
              },
              expression: "form.full_name"
            }
          }),
          _vm._v(" "),
          _c("AppInput", {
            staticClass: "form-group",
            attrs: {
              label: _vm.$t("Email"),
              error: _vm.ajax_error.errors && _vm.ajax_error.errors.email,
              warning: _vm.ajax_warnings && _vm.ajax_warnings.email,
              placeholder: _vm.$t("Email"),
              name: "email",
              dataTestId: "email"
            },
            on: {
              change: function($event) {
                return _vm.onBlurChangeWarning("email")
              }
            },
            model: {
              value: _vm.form.email,
              callback: function($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email"
            }
          }),
          _vm._v(" "),
          _c("AppInput", {
            staticClass: "form-group has-country align-items-center",
            attrs: {
              label: _vm.$t("Phone Number"),
              error:
                _vm.ajax_error &&
                _vm.ajax_error.errors &&
                _vm.ajax_error.errors.phone_number,
              warning: _vm.ajax_warnings && _vm.ajax_warnings.phone_number,
              placeholder: _vm.$t("Phone"),
              name: "phone_number",
              dataTestId: "phone-number"
            },
            on: {
              change: function($event) {
                return _vm.onBlurChangeWarning("phone_number")
              }
            },
            model: {
              value: _vm.form.phone_number,
              callback: function($$v) {
                _vm.$set(_vm.form, "phone_number", $$v)
              },
              expression: "form.phone_number"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-wrap justify-content-end mt-3" },
            [
              _c(
                "AppButton",
                {
                  staticClass: "py-2 md-flat ml-2 mt-1",
                  staticStyle: { width: "100px" },
                  attrs: {
                    name: "close-modal-edit-creator",
                    outline: "",
                    type: "button",
                    "data-dismiss": "modal"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Close")))]
              ),
              _vm._v(" "),
              _c(
                "AppButton",
                {
                  staticClass: "py-2 md-flat ml-2 mt-1",
                  staticStyle: { width: "100px" },
                  attrs: { name: "save-modal-edit-creator", type: "Submit" }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }